/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import AutoCompleteTextField from 'material/autofilltext/autofilltext';



/* ========== ~~~~~~~~~~ ADDABLE EMAIL LIST : ADDABLE EMAIL ~~~~~~~~~~ ========== */
const AddableEmail = (props) => (
    <AutoCompleteTextField
        handleSelect={props.handleSelect}
        label={``} 
        type={`email`}
        list={props.allUsers}
        handleBlur = {props.handleBlur}
        value={props.value}
        valid={props.valid}
        name={`email`}
        required={props.required}
    />
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AddableEmail;
